import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class DataMonitorTaskService {
  // 获取实体对象采集任务总数
  static async getTaskTotalCount(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataMonitorTask/task-total-count', payload)
    )
    return Callback(err, res)
  }
  // 获取实体对象采集数据总数
  static async getTaskDataTotalCount(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataMonitorTask/task-data-total-count', payload)
    )
    return Callback(err, res)
  }
  // 获取实体对象采集任务状态统计
  static async getTaskStatusTotal(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataMonitorTask/task-status-total', payload)
    )
    return Callback(err, res)
  }
  // 获取实体对象采集任务分布统计
  static async getTaskDistribution(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataMonitorTask/task-distribution', payload)
    )
    return Callback(err, res)
  }
  // 获取实体对象采集排行
  static async getTaskRanking(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataMonitorTask/task-ranking', payload)
    )
    return Callback(err, res)
  }
  // 获取实体对象采集清单列表
  static async getPagedTaskTotalList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataMonitorTask/paged-task-total-list', payload)
    )
    return Callback(err, res)
  }
}
